import * as React from "react";
import { useState, useEffect } from "react";
import Card from "../core/Card";
import OrgProfile from "../org/OrgProfile";
import OrgCW from "../org/OrgCW";
import { RailsUserContext } from "../../libs/user_context";
import { inOrg } from "../../libs/user";
import OrgEmployeeList from "../org/OrgEmployeeList";
import Button from "../core/Button";
import { Link } from "react-router-dom";
import EmployeeSubordinatesList from "../employee/EmployeeSubordinatesList";
import { jfetch, toast } from "../../utils";
import Modal from "../core/Modal";
import axios from 'axios'
import { useSpring, animated } from "react-spring";


interface IProps {
  org: IOrganization;
  currentUser?: IUser;
  owner?: IUser;
  cw: IJsonApiResponse<ICwMemberRecord>;
  sponsorPage: any;
}

function OrgOverview({ org, currentUser, cw, owner, sponsorPage }: IProps) {
  const userInOrg = inOrg(currentUser, org);
  const [loading, setLoading] = useState(false);
  const showManagerList = currentUser.isManager;

  const hasSponsorPage = (sponsorPage == null ? false : true);

  const canInviteUser =
    currentUser.isAdmin || currentUser.isOwner || currentUser.isManager;

  const canViewOnboarding = currentUser.isOwner || currentUser.isAdmin;

  const canViewOwnerTransfer = currentUser.isOwner || currentUser.isAdmin;

  const canViewCWInfo = currentUser.isAdmin;

  const canViewStrategyDoc = currentUser.isOwner || currentUser.isAdmin;

  const canViewIntegration = currentUser.isOwner || currentUser.isAdmin || currentUser.isManager;

  const toggleStatus = () => {
    setLoading(true)
    jfetch
    .get(`/organizations/${org.id}/toggle_status`)
    .then(() => {
      org.active = !org.active
      setLoading(false)
    })

  }

  return (
    <>
      <div className="level">
        <div className="level-left">
          {canViewOnboarding && (
            <div className="level-item">
              {currentUser.isAdmin ? (
                <Link to={"/onboarding_data"}>
                  <Button>Onboarding</Button>
                </Link>
              ) : (
                <a href={"/onboarding"}>
                  <Button>Onboarding</Button>
                </a>
              )}
            </div>
          )}
          {canInviteUser && (
            <div className="level-item">
              <Link to={"/invite"}>
                <Button>Invite User</Button>
              </Link>
            </div>
          )}
          {canViewOwnerTransfer && (
            <div className="level-item">
              <Link to={"/transfer_owner"}>
                <Button>Transfer Ownership</Button>
              </Link>
            </div>
          )}
          {canViewStrategyDoc && (
            <div className="level-item">
              <Link to={"/strategyplan"}>
                <Button>Strategic Plan</Button>
              </Link>
            </div>
          )}
          {hasSponsorPage && (
            <div className="level-item">
                <Button href={"/sponsor/rooms/" + sponsorPage}>Sponsor Booth</Button>
            </div>
          )}
          {canViewIntegration && (
            <div className="level-tiem">
              <IntegrationModal org={org} cw={cw}/>
            </div>
          )}
        </div>
        <div className="level-right">
          {currentUser.isAdmin && (
            <div className="level-item">
              {org.active ? (
                <Button color="danger" loading={loading} onClick={toggleStatus}>Disable Organization</Button>
              ) : (
                <Button color="success" loading={loading} onClick={toggleStatus}>Activate Organization</Button>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="columns">
        <div className="column is-8">
          {userInOrg && showManagerList ? (
            <Card title="My Managed Employees">
              <EmployeeSubordinatesList user={currentUser} />
            </Card>
          ) : null}
          <Card title="All Users">
            <OrgEmployeeList org={org} />
          </Card>
        </div>
        <div className="column is-4">
          <Card title="Org Details">
            <OrgProfile org={org} owner={owner} />
          </Card>
          {canViewCWInfo && (
            <>
              {/* <Card title="Membership Info">
                <OrgMember org={org} cw={cw} />
              </Card> */}
              <Card title="Permissions Group">
                <Groups org={org} />
              </Card>
              <Card title="ConnectWise Info">
                <OrgCW org={org} cw={cw} />
              </Card>
            </>
          )}
        </div>
      </div>
    </>
  );
}

interface groupProps{
  org:IOrganization;
}
function Groups(props:groupProps){
  const [loading, setLoading] = useState(false)
  const [groups, setGroups]= useState([])
  const [groupID, setGroupID] = useState(0)

  useEffect(() => {
    let gs = []
    jfetch.get('/permissions/groups')
    .then((resp) => {
      resp.data.forEach(group => {
        gs.push(group.attributes)
      });
      setGroups(gs)
    })
    jfetch.get(`/organizations/${props.org.id}`)
    .then((resp) => {
      setGroupID(resp.permissions_group_id)
    })
  }, [])

  function handleSave(){
    setLoading(true)
    jfetch.post(`/organizations/${props.org.id}/update_group`, {groupID:groupID})
    .then((resp) => {
      setLoading(false)
    })
    .catch((error) => {
      toast.error('error saving group')
    })
  }

  return (
    <>
      <select className="form-control" value={groupID} onChange={(e) => setGroupID(parseFloat(e.target.value))} style={{marginBottom:'15px'}}>
        {groups.map((group) => {
          return <option key={group.id} value={group.id}>{group.name}</option>
        })}
      </select>
      <Button
        color={"primary"}
        size={"sm"}
        onClick={handleSave}
        loading={loading}
        disabled={loading}
      >
        Update
      </Button>
    </>
  )
}

interface IMprops{
  org: IOrganization;
  cw:IJsonApiResponse<ICwMemberRecord>;
}

function IntegrationModal(props:IMprops){
  const [showModal, setShowModal] = useState(false)
  const [view, setView] = useState('cw')
  const [cwUrl, setCwUrl] = useState('')
  const [cwCompany, setCwCompany] = useState('')
  const [cwPublic, setCwPublic] = useState('')
  const [cwPrivate, setCwPrivate] = useState('')
  const [cwToken, setCwToken] = useState('')
  const [acUrl, setAcUrl] = useState('')
  const [acKey, setAcKey] = useState('')
  const [savedKeys, setSavedKeys] = useState(false)
  const [companyTypes, setCompanyTypes] = useState([])
  const [customerTypes, setCustomerTypes] = useState([])
  const [prospectTypes, setProspectTypes] = useState([])
  const [marketingLists, setMarketingLists] = useState([])
  const [masterLists, setMasterLists] = useState([])
  const [customerLists, setCustomerLists] = useState([])
  const [prospectLists, setProspectLists] = useState([])
  const [jobs, setJobs] = useState([])
  const [CWjobs, setCWJobs] = useState([])
  const [inactiveFlag, setInactiveFlag] = useState(true)
  const [updateLoading, setUpdateLoading] = useState(false)
  const [atApi, setAtApi] = useState('')
  const [atUrl, setAtUrl] = useState('')
  const [atUser, setAtUser] = useState('')
  const [atPassword, setAtPassword] = useState('')
  const [callbacks, setCallbacks] = useState([])
  const [creating, setCreating] = useState(false)

  const cwData = (props.cw && props.cw.data && props.cw.data.attributes) ? props.cw.data.attributes : null;


  useEffect(() => {
    axios
    .get(`https://api.chartec.net/v2/connectwise/company/types/${cwData.cwRecid}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`)
    .then((resp) => {
      setCompanyTypes(resp.data)
    })
    getJobs()
  }, []);


  useEffect(() => {
    if(acUrl != '' && acKey != ''){
      jfetch 
      .get(`/ac/lists`, {url:acUrl, key:acKey})
      .then((resp) => {
        let new_ls = []
        resp.result.lists.forEach(l => {
          new_ls.push({id:l.id, name:l.name})
        });
        setMarketingLists(new_ls)
      })
    }
  }, [acUrl, acKey])


  useEffect(() => {
    jfetch.get(`/organizations/${props.org.id}/integrations`)
    .then((resp) => {
      if(resp.connectwise != null){
        resp.connectwise.data.hasOwnProperty('cwUrl') ? setCwUrl(resp.connectwise.data['cwUrl']) : setCwUrl('')
        resp.connectwise.data.hasOwnProperty('cwCompany') ? setCwCompany(resp.connectwise.data['cwCompany']) : setCwCompany('')
        resp.connectwise.data.hasOwnProperty('cwPublic') ? setCwPublic(resp.connectwise.data['cwPublic']) : setCwPublic('')
        resp.connectwise.data.hasOwnProperty('cwPrivate') ? setCwPrivate(resp.connectwise.data['cwPrivate']) : setCwPrivate('')
        if (resp.connectwise.data.hasOwnProperty('cwToken')){  
          setCwToken(resp.connectwise.data['cwToken'])
          if(resp.connectwise.data['cwToken'] != ''){
            setSavedKeys(true)
          }
        } 
        else{
          setCwToken('')
        }  
      }
      if(resp.activecampaign != null){
        setAcUrl(resp.activecampaign.data.acUrl || '')
        setAcKey(resp.activecampaign.data.acKey || '')
        setCustomerTypes(resp.activecampaign.data.customerTypes || [])
        setProspectTypes(resp.activecampaign.data.prospectTypes || [])
        setMasterLists(resp.activecampaign.data.masterLists || [])
        setCustomerLists(resp.activecampaign.data.customerLists || [])
        setProspectLists(resp.activecampaign.data.prospectLists || [])
      }
      if(resp.autotask != null){
        setAtApi(resp.autotask.data.atApi || '0')
        setAtUrl(resp.autotask.data.atUrl || '')
        setAtUser(resp.autotask.data.atUser || '')
        setAtPassword(resp.autotask.data.atPassword || '')
      }      
    })
  }, [])
  

  useEffect(() => {
    //check that has cw keys 
    if(setSavedKeys){
      getCallbacks()
    }
  }, [])

  async function getCallbacks(){
    let cbs = [];
    const resp = await fetch(`https://api.chartec.net/v2/connectwise/callback/${cwData.cwRecid}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`)
    const json = await resp.json()
    json.forEach( callback => {  
      if(callback.url.includes("api.chartec.net/v2/connectwise/webhook/cw/cache/activity") || callback.url.includes("api.chartec.net/v2/activecampaign/webhook/cw/contact") || callback.url.includes("api.chartec.net/v2/activecampaign/webhook/cw/company") || callback.url.includes("api.chartec.net/v2/connectwise/webhook/cw/cache/schedule")){
        cbs.push(callback)
      }
    });
    setCallbacks(cbs)
  }

  async function createCallback(type, desc, target_url){
    await fetch(`https://api.chartec.net/v2/connectwise/callback/${cwData.cwRecid}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`, {
      method: 'POST', 
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({"type": type, "description":desc, "url": target_url})
    })
  }

  async function genCallbacks(){
    setCreating(true)
    const key = btoa(`234bvnb4lg45kdss3433${cwData.cwRecid}`)
    if(!has_callback('api.chartec.net/v2/activecampaign/webhook/cw/contact')){
      await createCallback(
        'contact', 
        'Contacts Callback (for Sync)',
        `https://api.chartec.net/v2/activecampaign/webhook/cw/contact/${key}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`
        )
    }
    if(!has_callback('api.chartec.net/v2/activecampaign/webhook/cw/company')){
      await createCallback(
        'company', 
        'Companies Callback (for Sync)',
        `https://api.chartec.net/v2/activecampaign/webhook/cw/company/${key}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`
        )
    }
    if(!has_callback('api.chartec.net/v2/connectwise/webhook/cw/cache/activity')){
      await createCallback(
        'activity', 
        'Activities Callback (for Sync)',
        `https://api.chartec.net/v2/connectwise/webhook/cw/cache/activity/${key}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`
        )
    }
    if(!has_callback('api.chartec.net/v2/connectwise/webhook/cw/cache/schedule/')){
      await createCallback(
        'schedule', 
        'Schedules Callback (for Sync)',
        `https://api.chartec.net/v2/connectwise/webhook/cw/cache/schedule/${key}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`
        )
    }
    await setTimeout(async function () {
      await getCallbacks()
      setCreating(false)
    }, 700);
  }

  function has_callback(str){
    let has_it = false 
    callbacks.forEach((callback) => {
      if(callback.url.includes(str)){
        has_it = true
      }
    })
    return has_it
  }


  function check(cur){
    return view == cur ? 'inherit' : 'none'
  }

  function saveKeys(){
    let s = 'Basic ' + btoa(`${cwCompany}+${cwPublic}:${cwPrivate}`)
    setCwToken(s)
    setSavedKeys(true)
  }

  function discardKeys(){
    setCwToken('')
    setCwPrivate('')
    setCwPublic('')
    setSavedKeys(false)
  }

  function updateArray(array, update_func, checked, val){
    const num = parseInt(val)
    let array_copy = [...array]
    checked ? array_copy.push(num) : array_copy = array_copy.filter((i) => i != num)
    update_func(array_copy)
  }

  async function createCWJob(){
    const can_run = (cwUrl && cwCompany && cwPublic && cwPrivate && cwToken)
    if(can_run){
        //Check if is in companies
        const resp = await fetch(`https://api.chartec.net/v2/core/cache/check/${cwData.cwRecid}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`)
        const json = await resp.json()
        if(!Array.isArray(json) || !json.length){
          //add to companies if does not exist
          const resp_add = await fetch(`https://api.chartec.net/v2/core/cache/add/${cwData.cwRecid}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`)
        }

        // Create CW Sync Job
        const api_resp = await fetch(`https://api.chartec.net/v2/core/jobs/${cwData.cwRecid}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`, {
          method: 'POST', 
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({"type":"cw_init_sync"})
        })
        const api_json = await api_resp.json()
        await jfetch.post('/integrations/jobs', { job:
          {
            status:'created', 
            job_id:api_json.job_id,
            organization_id: props.org.id
          }
        })
        getJobs()
    }
  }

  function createJob(){
    const can_run = (cwUrl && cwCompany && cwPublic && cwPrivate && cwToken && acUrl && acKey && customerTypes && prospectTypes && masterLists && customerLists && prospectLists)
    if(!can_run){
      toast.error('Please fill out all ActiveCampaign and ConnectWise forms first.')
    }
    else{
      ( async() => {
        await submitHandle(true)
        const api_resp = await axios.post(`https://api.chartec.net/v2/core/jobs/${cwData.cwRecid}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`, {
          'type':'ac_init_sync'
        })
        const api_json = await api_resp.data
        toast.success('Job was scheduled')
        await jfetch.post('/integrations/jobs', { job:
          {
            status:'created', 
            job_id:api_json.job_id,
            organization_id: props.org.id
          }
        })
        getJobs()
      })()
    }
  }

  function getJobs(){
    axios 
    .get(`https://api.chartec.net/v2/core/jobs/${cwData.cwRecid}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`)
    .then((resp) => {
      let api_jobs = resp.data.filter(job => job.type == 'ac_init_sync')
      let cw_api_jobs = resp.data.filter(job => job.type == 'cw_init_sync')
      setCWJobs(cw_api_jobs)
      setJobs(api_jobs)
    })
  }

  function toggleJob(id, action){
    axios
    .post(
      `https://api.chartec.net/v2/core/jobs/${cwData.cwRecid}/${id}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`, 
      {action: action}, 
      {headers:{'Content-Type':'application/json', 'Accept':'*/*'}}
    )
    .then((resp) => {
      let jobs_copy = [...jobs]
      jobs_copy.forEach( job => {
        if(job.id == id){
          if(+job.processed){
            job.processed = '0'
          }
          else{
            job.processed = '1'
          }
        }
      })
      setJobs(jobs_copy)
    })
  }  

  async function submitHandle(silent){

    let resp = await submitAPI()
    if(resp.status == 200){
      submitCORE(silent)
    }
    else{
      setShowModal(false)
      toast.error('Error saving settings')
    }

    if (!Array.isArray(CWjobs) || !CWjobs.length) {
      createCWJob()
    }
  }

  async function submitCORE(silent){
    const cw = {
      name: 'connectwise',
      data: {
        cwUrl: cwUrl,
        cwCompany: cwCompany,
        cwPublic: cwPublic, 
        cwPrivate: cwPrivate, 
        cwToken: cwToken
      },
      organization_id: props.org.id
    }
    const ac = {
      name: 'activecampaign', 
      data: {
        acUrl: acUrl,
        acKey: acKey,
        customerTypes: customerTypes,
        prospectTypes: prospectTypes,
        masterLists: masterLists,
        customerLists: customerLists,
        prospectLists: prospectLists              
      },
      organization_id: props.org.id
    }
    const at = {
      name: 'autotask',
      data: {
        atApi: atApi,
        atUrl: atUrl,
        atUser: atUser,
        atPassword: atPassword      
      },
      organization_id: props.org.id
    }
    await jfetch.patch(`/organizations/${props.org.id}/update_integrations`, {integrations:[cw,ac,at]})
    if(silent == false){
      setShowModal(false)
      toast.success("Settings have been updated")
    }
  }

  async function submitAPI(){
    return await fetch(`https://api.chartec.net/v2/core/settings/${cwData.cwRecid}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`, {
      method: 'POST', 
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'cw_url': cwUrl,
        'cw_company': cwCompany,
        'cw_public': cwPublic, 
        'cw_private': cwPrivate, 
        'cw_token': cwToken, 
        'cw_client_types': customerTypes,
        'cw_prospect_types': prospectTypes,
        'ac_url': acUrl,
        'ac_key': acKey,
        'ac_client_lists': customerLists,
        'ac_prospect_lists': prospectLists,
        'ac_master_lists': masterLists,
        'at_api': +atApi,
        'at_url': atUrl,
        'at_user': atUser,
        'at_password': atPassword,
        'marketing_contacts': null
      })
    })     
  }

  function display_data(job, col){
    //parse string
    let j = JSON.parse(job)
    // if an emptry array return blank
    if(Array.isArray(j)){
      return '--'
    }
    // if property exists and job is not null
    if(j != null && col in j){
      // if data is not null
      if(j[col] != null){
        return j[col]
      }
      else{
        return '--'
      }
    }
    else{
      return '--'
    }
  }


  return (
    <div id="software-integ-modal">
      <Button onClick={() => setShowModal(true)}>
        Software Integration
      </Button>
      <Modal
        title={"Software Integrations"}
        open={showModal}
        close={() => setShowModal(false)}
        submittable={true}
        isLarge={true}
        disallowClickOutside={true}
        submitText="Save"
        onSubmit={() => submitHandle(false)}
      >       
        <div className="container-fluid" style={{margin:'0px'}}>
          <div className="row">
            <div className="col-lg-2">
              <div className="row menu-row" onClick={() => setView('cw')}>
                <div className="col-lg-12 menu-col">
                  <a>ConnectWise</a>
                </div>
              </div>
              {/* <div className="row menu-row" onClick={() => setView('ac')}>
                <div className="col-lg-12 menu-col">
                  <a>ActiveCampaign</a>
                </div>
              </div>  */}
              <div className="row menu-row" onClick={() => setView('at')}>
                <div className="col-lg-12 menu-col">
                  <a>Autotask</a>
                </div>
              </div>
            </div>
            <div className="col-lg-10">
              <div style={{display:check('cw')}}>
                <h3 className="text-center" style={{color:'black'}}>ConnectWise</h3>
                <div className="form-group">
                  <label>ConnectWise API Host</label>
                  <input value={cwUrl} onChange={(e) => setCwUrl(e.target.value)} type="text" className="form-control"/>
                </div>
                <div className="form-group">
                  <label>ConnectWise Site ID</label>
                  <input value={cwCompany} onChange={(e) => setCwCompany(e.target.value)} type="text" className="form-control"/>
                </div>
                { savedKeys ? (
                  <Card>
                    <div className="sync-title-div">
                      <h5 className="text-center" style={{color:'black'}}>Saved Keys</h5>
                    </div>
                    <div className="form-group">
                      <label>Public Key</label>
                      <input value={cwPublic} readOnly={true} type="text" className="form-control"/>
                    </div>
                    <div>
                      <Button color="danger" onClick={discardKeys}>
                        Remove Keys
                      </Button>
                    </div>
                  </Card>     
                ) : (
                  <Card>
                    <div className="sync-title-div">
                      <h5 className="text-center" style={{color:'black'}}>ConnectWise Rest Keys</h5>
                    </div>
                    <div className="form-group">
                      <label>Public Key</label>
                      <input value={cwPublic} onChange={(e) => setCwPublic(e.target.value)} type="text" className="form-control"/>
                    </div>
                    <div className="form-group">
                      <label>Private Key</label>
                      <input value={cwPrivate} onChange={(e) => setCwPrivate(e.target.value)} type="text" className="form-control"/>
                    </div> 
                    <div>
                      <Button color="info" onClick={saveKeys}>
                        Set Keys
                      </Button>
                    </div>
                  </Card>                                 
                )}                                          
              </div>
              {/* <div style={{display:check('ac')}}>
                <h3 className="text-center" style={{color:'black'}}>ActiveCampaign</h3>
                <div className="form-group">
                  <label>ActiveCampaign URL</label>
                  <input value={acUrl} onChange={(e) => setAcUrl(e.target.value)} type="text" className="form-control"/>
                </div>
                <div className="form-group">
                  <label>API Key</label>
                  <input value={acKey} onChange={(e) => setAcKey(e.target.value)} type="text" className="form-control"/>
                </div>
                <div>
                <div className="alert alert-info alert-dismissible">
                  <a href="#" className="close" data-dismiss="alert" aria-label="close">&times;</a>
                  <strong>We&apos;ve added a Connectwise/ActiveCampaign contact sync integration into Core.</strong><br/>
                  This allows you to sync contacts from Connectwise into your ActiveCampaign marketing lists.
                  Select your options below.
                </div>
                </div>
                <Card>
                  <div style={{textAlign:'center'}}>
                  <div>
                    <h5 className="text-center" style={{color:'black'}}>Sync Options</h5>
                  </div>
                  <div className="row sync-title-div">
                    <div className="col-lg-5">
                      <h5 style={{color:'black'}}>ConnectWise Types:</h5>
                    </div>
                    <div className="col-lg-2"/>
                    <div className="col-lg-5">
                      <h5 style={{color:'black'}}>ActiveCampaign Lists:</h5>
                    </div>
                  </div>
                  <div className="row sync-section">
                    <CheckboxSection
                      options={companyTypes}
                      selected={customerTypes}
                      label='Source: Customer'
                      changed={(bool, val) => updateArray(customerTypes, setCustomerTypes, bool,  val)}
                    />
                    <div className="col-lg-2 text-center" style={{color:'black', fontSize:'22px'}}>
                      ➡
                    </div>
                    <CheckboxSection
                      options={marketingLists}
                      selected={customerLists}
                      label='Destination: Customer'
                      changed={(bool, val) => updateArray(customerLists, setCustomerLists, bool,  val)}
                    />
                  </div>
                  <div className="row sync-section">
                    <CheckboxSection
                      options={companyTypes}
                      selected={prospectTypes}
                      label='Source: Prospect'
                      changed={(bool, val) => updateArray(prospectTypes, setProspectTypes, bool,  val)}
                    />
                    <div className="col-lg-2 text-center" style={{color:'black', fontSize:'22px'}}>
                      ➡
                    </div>
                    <CheckboxSection
                      options={marketingLists}
                      selected={prospectLists}
                      label='Destination: Prospect'
                      changed={(bool, val) => updateArray(prospectLists, setProspectLists, bool,  val)}
                    />
                  </div>
                  <div className="row sync-section" style={{borderBottom:'none'}}>
                      <div className="col-lg-5">
                        <label>Source: All Types ({companyTypes.length})</label>
                      </div>
                      <div className="col-lg-2 text-center" style={{color:'black', fontSize:'22px'}}>
                        ➡
                      </div>                      
                      <CheckboxSection
                        options={marketingLists}
                        selected={masterLists}
                        label='Destination: Master'
                        changed={(bool, val) => updateArray(masterLists, setMasterLists, bool,  val)}
                      />
                    </div>
                    </div>                                          
                </Card>
                <Card>
                  <div className="sync-title-div">
                    <h5 className="text-center" style={{color:'black'}}>Sync (ConnectWise ➡ ActiveCampaign)</h5>
                  </div>                  
                  <div style={{paddingTop:'13px'}}>
                    <table className="table">
                      <tr>
                        <th style={{color:'black'}}>Callback</th>
                        <th style={{color:'black'}}>Status</th>
                      </tr>
                      {callbacks.map((callback) =>  <CallbackRow callback={callback} key={callback.id} cwRecid={cwData.cwRecid} />)}
                    </table>  
                  </div>
                  { (callbacks.length < 4) && (
                    <div>
                      <Button color="primary" onClick={genCallbacks} loading={creating}>Generate Callbacks</Button>  
                    </div>
                  )}     
                </Card>                
                <Card>
                  <div style={{paddingBottom:'8px', paddingTop:'10px', marginBottom:'15px', textAlign:'right'}}>
                    <Button color="info" onClick={createJob}>
                      Create Seed Job
                    </Button> 
                  </div>
                  <div className="alert alert-warning alert-dismissible">
                    <a href="#" className="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <strong>Caution</strong><br/>
                    Running a seed job will import all of your contacts from ConnectWise into your ActiveCampaign marketing lists based on types and lists you've selected above.
                  </div>                  
                  <div className="sync-title-div"> 
                    <h5 className="text-center" style={{color:'black'}}>Seed Jobs</h5>
                  </div>                                
                  <div>
                    <table className="table text-center" style={{marginTop:'12px'}}>
                      <tr>
                        <th style={{color:'black', textAlign:'center'}}>Job ID</th>
                        <th style={{color:'black', textAlign:'center'}}>Companies Processed</th>
                        <th style={{color:'black', textAlign:'center'}}>Percent</th>
                        <th style={{color:'black', textAlign:'center'}}>Complete</th>
                        <th style={{color:'black', textAlign:'center'}}>Toggle Status</th>
                      </tr>
                      {jobs.map((job) => {
                        return (
                          <tr key={job.job_id}>
                            <td style={{paddingTop:'8px', paddingBottom:'8px'}}>{job.id}</td>
                            <td style={{paddingTop:'8px', paddingBottom:'8px'}}>
                            {display_data(job.json, 'companies_processed')} / {display_data(job.json, 'companies_found')} 
                            </td>
                            <td style={{paddingTop:'8px', paddingBottom:'8px'}}>
                              {display_data(job.json, 'percent_complete')} %
                            </td>
                            <td style={{paddingTop:'8px', paddingBottom:'8px'}}>{+job.processed ? 'yes' : 'no'}</td>
                            <td style={{paddingTop:'8px', paddingBottom:'8px'}}>
                              {+job.processed ? (
                                <Button color="success" onClick={() => toggleJob(job.id, 'restart')}>
                                  Restart
                                </Button>
                              ) : (
                                <Button color="danger" onClick={() => toggleJob(job.id, 'cancel')}>
                                  Cancel
                                </Button>
                              )}

                            </td>
                          </tr>
                        )
                      })}
                    </table>
                  </div>
                </Card>              
              </div> */}
              <div style={{display:check('at')}}>
                <h3 className="text-center" style={{color:'black'}}>Autotask</h3>
                <div className="form-group">
                  <label>Enable Autotask API</label>
                  <div style={{display:'flex', justifyContent:'center'}} className="text-center">
                    <input 
                      type="radio" 
                      style={{width:'inherit', height:'auto'}} 
                      checked={atApi == '0'}
                      onChange={(e) => setAtApi(e.target.value)}
                      value="0"
                    /> No
                    <input 
                      type="radio" 
                      style={{width:'inherit', height:'auto', marginLeft:'15px'}} 
                      checked={atApi == '1'}
                      onChange={(e) => setAtApi(e.target.value)}
                      value="1"
                    /> Yes 
                  </div>    
                </div>
                <div className="form-group">
                  <label>Autotask URL</label>
                  <input value={atUrl} onChange={(e) => setAtUrl(e.target.value)} type="text" className="form-control"/>
                </div>
                <div className="form-group">
                  <label>Autotask User</label>
                  <input value={atUser} onChange={(e) => setAtUser(e.target.value)} type="text" className="form-control"/>
                </div>
                <div className="form-group">
                  <label>Autotask Password</label>
                  <input value={atPassword} onChange={(e) => setAtPassword(e.target.value)} type="text" className="form-control"/>
                </div>                                                
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}


interface CSprops {
  label:string;
  options:any[];
  selected:any[];
  changed:Function;
}

function CheckboxSection(props:CSprops){
  const [open, setOpen] = useState(false)
  const toggleB = open ? <i className="fa fa-minus-square"/> : <i className="fa fa-plus-square"/>
  const fade = useSpring({
    opacity: open ? 1 : 0,
    display: open ? 'block' : 'none'
  })
  return(
    <div className="col-lg-5">
      <div className="form-group">
      <label>
        {props.label} ({props.selected.length}) 
        <a style={{marginLeft:'7px'}} onClick={() => setOpen(!open)}>
          {toggleB}
        </a>
      </label>
      </div>
      <animated.div style={fade}>
        <div className="checkbox-div">
          {props.options.map((option) => {
            return (
              <div className="input-div" key={option.id}>
                <input 
                  type="checkbox"
                  value={option.id} 
                  checked={props.selected.includes(+option.id)}
                  onChange={(event) => props.changed(event.target.checked, event.target.value)} 
                /> 
                <p style={{textAlign:'left'}}>{option.name}</p>
              </div>
            )
          })}
        </div>
      </animated.div>
    </div>    
  )
}

function CallbackRow(props){
  const [inactive, setInactive] = useState(true)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setInactive(props.callback.inactiveFlag)
  }, [])

  async function updateCallback(id, inactiveFlag){
    setLoading(true)
    await fetch(`https://api.chartec.net/v2/connectwise/callback/${props.cwRecid}/${id}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`, {
      method: 'POST', 
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({"inactiveFlag": `${inactiveFlag}`})
    })    
    setInactive(inactiveFlag)
    setLoading(false)
  }

  return (
    <tr>
      <td style={{paddingTop:'8px', paddingBottom:'8px'}}>{props.callback.description}</td>
      <td>
        { inactive ? (
          <Button color="danger" onClick={() => updateCallback(props.callback.id, !inactive)} loading={loading}>
            OFF <i className="fa fa-refresh" />
          </Button>
        ) : (
          <Button color="success" onClick={() => updateCallback(props.callback.id, !inactive)} loading={loading}>
            ON <i className="fa fa-refresh" />
          </Button>
        )}
      </td>
    </tr>
  )
}

export default (props: IProps) => (
  <RailsUserContext.Consumer>
    {userContext => <OrgOverview {...props} currentUser={userContext.user} />}
  </RailsUserContext.Consumer>
);



// WEBPACK FOOTER //
// ./app/javascript/components/org/OrgOverview.tsx